<div class="page-container">

  <!-- SOLDE TOTAL -->
  <div class="total-balance-card">
    <span class="label">Total solde marchand</span>
    <span class="amount">{{ grandTotal | number:'1.0-0' }} XOF</span>
  </div>

  <!-- SOLDE PAR TITRE -->

  <h2 class="section-title">Soldes par titre</h2>
  <div class="titles-grid">
    <div class="title-card" *ngFor="let titre of soldesParTitre">
      <div class="title-info">
        <div class="text-info">
          <div class="titre">{{ titre.label }}</div>
          <div class="solde">Solde disponible</div>
        </div>
      </div>
      <div class="card-footer">
        <span class="amount-small">{{ titre.solde | number:'1.0-0' }} XOF</span>
      </div>
    </div>

    <!-- Bons Marchand — même niveau, même taille, même affichage que les titres classiques -->
    <div class="title-card" *ngIf="!loadingBonsMarchand">
      <div class="title-info">
        <div class="text-info">
          <div class="titre">Bons Marchand</div>
          <div class="solde">Solde disponible</div>
        </div>
      </div>
      <div class="card-footer">
        <span class="amount-small">{{ bonsMarchandTotal | number:'1.0-0' }} XOF</span>
      </div>
    </div>
  </div>

  <div *ngIf="loadError" class="load-error-banner">
    Certains soldes n'ont pas pu être chargés.
  </div>

</div>